import { render } from "./TasksView.vue?vue&type=template&id=9812b52a&scoped=true&ts=true"
import script from "./TasksView.vue?vue&type=script&lang=ts"
export * from "./TasksView.vue?vue&type=script&lang=ts"

import "./TasksView.vue?vue&type=style&index=0&id=9812b52a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9812b52a"]])

export default __exports__